import { imageAssets } from '@/assets/images'
import type { WebsiteContent } from './types'

export const team: WebsiteContent['team'] = {
  title: 'Who we are',
  subtitle: 'Our Team',
  description:
    "Our team of strategists, scientists, and creatives live, breathe and shape AI for what comes next. We're builders, and we wouldn't have it any other way.",
  members: [
    {
      name: 'Andrew Fegley',
      role: 'Founding Partner',
      image: imageAssets.team.members[0],
      linkedInUrl: 'https://www.linkedin.com/in/andrewfegley/',
    },
    {
      name: 'Robert Koch',
      role: 'Founding Partner',
      image: imageAssets.team.members[1],
      linkedInUrl: 'https://www.linkedin.com/in/ai-rob/',
    },
    {
      name: 'Jonathan Lupo',
      role: 'Founding Partner',
      image: imageAssets.team.members[2],
      linkedInUrl: 'https://www.linkedin.com/in/interactiondesign/',
    },
    {
      name: 'Shane Brennan',
      role: 'CTO',
      image: imageAssets.team.members[3],
      linkedInUrl: 'https://www.linkedin.com/in/shaneebrennan/',
    },
  ],
}
